import type { ComponentPropsWithRef } from "react";
import Loader from "@/components/ui/loader.tsx";
import { cn } from "@/utils/style.ts";

export function Overlay({ children, className, ...props }: ComponentPropsWithRef<"div">) {
    return (
        <div {...props} className={cn("overlay", className)}>
            {children}
        </div>
    );
}

export function OverlayContent({ children, className, ...props }: ComponentPropsWithRef<"div">) {
    return (
        <div {...props} className={cn("overlay__content", className)}>
            {children}
        </div>
    );
}

type OverlaySpinnerProps = Omit<ComponentPropsWithRef<"div">, "children">;
export function OverlaySpinner({ className, ...props }: OverlaySpinnerProps) {
    return (
        <OverlayContent {...props} className={cn("grid place-items-center", className)}>
            <Loader />
        </OverlayContent>
    );
}
